/**
 * Utility functions for managing query parameters in Table component
 * Follows Single Responsibility Principle - each function has one clear purpose
 */

const PRESERVED_PARAMS = ['tab', 'status'];

/**
 * Preserves specific query parameters when updating table query string
 * @param {string} currentSearch - Current location.search string
 * @param {string} newQueryString - New query string from table (may include ?)
 * @returns {string} Final query string with preserved params
 */
export function preserveQueryParams(currentSearch, newQueryString) {
    const currentParams = new URLSearchParams(currentSearch);
    const newParams = new URLSearchParams(newQueryString.replace(/^\?/, ''));

    // Preserve specified params from current URL
    PRESERVED_PARAMS.forEach((param) => {
        const value = currentParams.get(param);
        if (value) {
            newParams.set(param, value);
        }
    });

    const queryString = newParams.toString();

    return queryString ? `?${queryString}` : '';
}

